import environment from '../environment'

export const getFullUrl = key => {
  let url
  if (key.includes('http')) {
    url = `public/${key}`
  }
  if (key.includes('public')) {
    url = `${environment.receiptS3Bucket}/${key}`
  }
  if (key.includes('public') && key.includes('http')) {
    url = `${key}`
  }

  if (!key.includes('public') && !key.includes('http')) {
    url = `${environment.receiptS3Bucket}/public/${key}`
  }

  return url
}
